import makeStyles from '@mui/styles/makeStyles';

const styles = (isOnViewMode: boolean) =>
  makeStyles(() => ({
    container: {
      position: "relative",
      minHeight: "100%",
      paddingBottom: "40px",
    },
    buttons: {
      position: "absolute",
      bottom: 0,
      marginLeft: "0.5rem",
    },
    actionsButtons: {
      position: "absolute",
      right: 0,
      border: 0,
    },
    headerWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& > span": {
        font: isOnViewMode ? "700 18px/18px Manrope" : "600 20px/24px Manrope",
        marginRight: "15px",
        color: "#465869",
      },
      "& ul": {
        listStyle: "none",
        padding: 0,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        "& li": {
          font: "500 16px/20px Manrope",
          color: "#9CA6AF",

          display: "flex",
          alignItems: "center",
          gap: "4px",
          margin: "0",
          "& > span": {
            "&.value": {
              color: "#465869",
            },
          },
        },
      },
    },
  }));

export default styles;
